// extracted by mini-css-extract-plugin
export var loadingSpinner = "_x-0";
export var spinnerContainer = "_x-1";